import React, { useState, useEffect } from 'react';
import { Download, X } from 'lucide-react';

export default function PWAInstall() {
  const [prompt, setPrompt] = useState(null);
  const [showBanner, setShowBanner] = useState(false);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    // Detect if already installed as PWA
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setInstalled(true);
      return;
    }

    const handler = (e) => {
      e.preventDefault();
      setPrompt(e);
      // Show banner after 5 seconds
      setTimeout(() => setShowBanner(true), 5000);
    };

    window.addEventListener('beforeinstallprompt', handler);
    window.addEventListener('appinstalled', () => {
      setInstalled(true);
      setShowBanner(false);
      setPrompt(null);
    });

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const install = async () => {
    if (!prompt) return;
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === 'accepted') {
      setInstalled(true);
    }
    setShowBanner(false);
    setPrompt(null);
  };

  if (installed || !showBanner || !prompt) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 sm:left-auto sm:right-4 sm:w-80">
      <div className="bg-zinc-900 border border-orange-500/30 rounded-2xl p-4 shadow-xl shadow-black/40">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 bg-orange-500 rounded-xl flex items-center justify-center shrink-0">
            <Download size={18} className="text-white" />
          </div>
          <div className="flex-1">
            <p className="text-sm font-semibold text-white">Instalar OrcFácil</p>
            <p className="text-xs text-zinc-400 mt-0.5">
              Adicione à tela inicial para acesso rápido, mesmo sem internet
            </p>
          </div>
          <button onClick={() => setShowBanner(false)} className="text-zinc-600 hover:text-zinc-400 transition-colors shrink-0">
            <X size={16} />
          </button>
        </div>
        <div className="flex gap-2 mt-3">
          <button onClick={() => setShowBanner(false)}
            className="flex-1 text-xs text-zinc-400 hover:text-white border border-zinc-700 py-2 rounded-xl transition-colors">
            Agora não
          </button>
          <button onClick={install}
            className="flex-1 text-xs bg-orange-500 hover:bg-orange-400 text-white font-semibold py-2 rounded-xl transition-colors">
            Instalar
          </button>
        </div>
      </div>
    </div>
  );
}
